import axios from 'axios';

const useAxios = () => {
  const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_ENDPOINT}`,
    responseType: 'json',
    headers: { 'Content-Type': 'application/json' },
  });

  return axiosInstance;
};

export default useAxios;
